import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [AngularSvgIconModule, NgClass],
	selector: 'vp-accordion',
	templateUrl: './accordion.html',
})
export class AccordionComponent {
	variant = input<'accent' | 'base'>('base');
	title = input<string>('');
	isOpen = input<boolean>(false);
}
